import type { ButtonProps } from '@/components/buttons/Button'
import type { TooltipProps } from '@/components/Tooltip'
import { Button } from '@/components/buttons/Button'
import { Tooltip } from '@/components/Tooltip'
import clsx from 'clsx'
import { type ReactNode, forwardRef } from 'react'

import styles from './styles.module.scss'

export interface IconButtonProps extends ButtonProps {
  icon: ReactNode
  tooltipPosition?: TooltipProps['placement']
  tooltipText?: string
}

export const ICON_BUTTON_TEST_ID = 'icon-button-test-id'

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, icon, tooltipText, tooltipPosition, ...props }, ref) => {
    return (
      <Tooltip placement={tooltipPosition} title={tooltipText}>
        <Button
          data-testid={ICON_BUTTON_TEST_ID}
          className={clsx(styles.buttonContainer, className)}
          icon={icon}
          ref={ref}
          type="text"
          {...props}
        />
      </Tooltip>
    )
  },
)
IconButton.displayName = 'IconButton'
